<template>
  <v-card flat>
    <x-uploader
        label="申报附件"
        icon="attachment"
        :action="fileUri"
        v-model="items"
        :delete-remote="true"
        :disabled="review.statusId != 'unpub'"
        :size="Number(50)"
        description="单个附件大小不超过 50M."
    />
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import XUploader from '@/components/global/Uploader'
const baseURI = '/api/review/attachment';
export default {
  name: "Attachment",
  components: {XUploader},
  props: {
    review: Object
  },
  data: () => ({
    items: [],

  }),

  computed: {
    ...mapGetters(['funcIds', 'roleId']),
    fileUri() {
      const ownerId = this.review ? this.review.dbid : '';
      return `${baseURI}?ownerId=${ownerId}`;
    }
  },

  watch: {
    review(p) {
      this.axios
          .get(`${baseURI}?reviewId=${p.dbid}`)
          .then(rsp => this.items = rsp.data.items)
    }
  },

  methods: {
    onEditOk(item) {
      //console.log("in Income onEditOK");
      if (item) {
        if (!this.editDbid) {
          this.items.unshift(item);
        } else {
          const editIdx = this.items.findIndex((v) => v.dbid === item.dbid);
          this.items[editIdx] = window.xutil.clone(item);
        }
        this.items = this.items.sort((a, b) => a.rank >= b.rank);
      }
    },
    onDeleOk(item) {
      if (item) {
        const deleIdx = this.items.findIndex((v) => v.dbid === item.dbid);
        this.items.splice(deleIdx, 1);
      }
    }
  }
}
</script>

<style scoped>

</style>